/**
 * 搭載機器情報ページ用のスクリプト
 */
if (is_route('vehicle_device.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        vehicle_device_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.vehicle_device_event_set = function() {
    let base_id = '#vehicle_device-setting-modal';
    let csvSettingModalId = '#vehicle_device-csv-setting-modal';
    /* 検索関連 */

    //車両コード
    $(document).on('change', '#search-form-vehicle_code', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //車両名
    $(document).on('change', '#search-form-vehicle_name', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //車載器ID
    $(document).on('change', '#search-form-equipment_id', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //ステータス
    $(document).on('change', '#search-form-status', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //デジドラ
    $(document).on('change', '#search-form-digitacho_id', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //検索ボタン
    $(document).on('click', '#search-btn', function(e) {
        //TODO:グループ会社が選択されていない場合検索は行わない。
        let callback = null;
        let isExtendPageQuery =  true;
        let selector = '#search-form';
        let replaceSelector = '#contents';
        // チェックボックスの状態をクエリパラメータに反映させる
        let action = $(selector).prop('action');
        $('.event-type-check').each(function() {
            if (!$(this).prop('checked')) {
                _request.remove_parameters(action, [$(this).prop('name')]);
            }
        });
        $(selector).prop('action', action);
        //リスト更新
        load_contents(callback, isExtendPageQuery, selector, replaceSelector, false);
    });

    // 編集用モーダルを表示する
    $(document).on('click', '[data-vehicle_device-setting-modal]', function () {
        _modal.create(this, 'vehicle_device-setting-modal', ['id'], false);
    });

    // 編集用モーダルを表示する
    $(document).on('click', '[data-vehicle_device-edit-modal]', function () {
        _modal.create(this, 'vehicle_device-setting-modal', ['id'], false);
    });

    // 削除確認モーダル
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /**
     * モーダル内の処理
     */

    // 機種
    $(document).on('change', base_id+'-digitacho_model', function() {
        var selectedVal = $(this).val();
        var digitachoSelectedData = $(base_id+'-digitacho_id').find('option:selected').data('model');
        $(base_id+'-digitacho_id option').hide();
        if (selectedVal) {
            $(base_id+'-digitacho_id option').filter(function() {
                return $(this).data('model') == selectedVal;
            }).show();
        } else {
            $(base_id+'-digitacho_id option').show();
        }
        if(selectedVal != digitachoSelectedData) {
            $(base_id+'-digitacho_id').val('');
        }
    });

    // 搭載機器ID
    $(document).on('change', base_id+'-digitacho_id', function () {
        var selectedData = $(this).find('option:selected').data('model');
        $(base_id+'-digitacho_model').val(selectedData);
    });

    $(document).on('click', '#back_to_list_btn', function () {
        _modal.hide(base_id);
        // 保存して一覧に戻るボタン
        let callback = null;
        let isExtendPageQuery =  true;
        let selector = '#search-form';
        let replaceSelector = '#contents';
        //リスト更新
        load_contents(callback, isExtendPageQuery, selector, replaceSelector, false);
    });

    // 保存するボタン
    $(document).on('click', '#save_and_add_another_btn', function () {
        saveVehicleData('save_and_add_another_btn');
    });

    //保存して一覧に戻るボタン
    $(document).on('click', '#save_and_back_to_list_btn', function () {
        saveVehicleData('save_and_back_to_list_btn');
    });

    // 保存するボタン
    $(document).on('click', '#save_and_continue_editing_btn', function () {
        saveVehicleData('save_and_continue_editing_btn');
    });

    //データ保存処理
    function saveVehicleData(btnName) {
        let action = $(base_id + '-form').attr('action');
        let datas = $(base_id + '-form').serializeArray();
        $('.invalid-feedback').removeClass('is-invalid');
        $('.invalid-feedback').addClass('copy').text('');
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                if(btnName == 'save_and_add_another_btn') {
                    // 保存して連続登録するボタン
                    $(base_id + '-id').val('');
                }else if(btnName == 'save_and_back_to_list_btn') {
                    _modal.hide(base_id);
                    // 保存して一覧に戻るボタン
                    let callback = null;
                    let isExtendPageQuery =  true;
                    let selector = '#search-form';
                    let replaceSelector = '#contents';
                    //リスト更新
                    load_contents(callback, isExtendPageQuery, selector, replaceSelector, false);
                }else if(btnName == 'save_and_continue_editing_btn') {
                    // 保存するボタン
                    $(base_id + '-id').val(data.id);
                }
                toastr.success(data.messages);
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {
                    idName = base_id + '-' + name;
                    console.log(idName);
                    $(idName).addClass('is-invalid');
                    $(idName + '-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.warning(errorMessage);
            }
        });
    }

    // 一括のチェックボックスクリック時
    $(document).on('click', '#vehicle_device-all-check', function () {
        $(".vehicle_device-check").prop('checked', $(this).prop('checked'));
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // basic_idsの初期化
        let ids = [];
        // 検索フォームを配列化
        let data = $('#search-form').serializeArray();
        // チェックされていない場合はスキップ
        if($('.vehicle_device-check:checked').val() == null) {
            return false;
        }
        // basic_ids取得
        $('.vehicle_device-check:checked').map(function () {
            ids.push($(this).val());
        });
        data.push({'name' : 'ids', 'value' : ids});
        // ポスト送信を実行
        post(action, data);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', csvSettingModalId + '-csv', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).data('confirm-action');
        let datas = new FormData($(csvFormId).get(0));
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $("[data-csv-save-modal]").prop('disabled', true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(csvSettingModalId + '-csv-submit-message').removeClass('display-none');
            $(csvSettingModalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(csvSettingModalId + '-csv-error').removeClass('display-none');
                $(csvSettingModalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).attr('action');
        let datas = new FormData($(csvFormId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(csvSettingModalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}
